import { graphql } from '@/lib/graphql';

export const FlowsListSubscription = graphql(`
  subscription FlowsList($organizationId: Uuid!) {
    flows(
      where: { organizationId: { _eq: $organizationId }, deletedAt: { _isNull: true } }
      orderBy: { createdAt: ASC }
    ) {
      id
      name
      description
      currentPublicationId
      nodes
    }
  }
`);

export const FlowSubscription = graphql(`
  subscription Flow($flowId: Uuid!) {
    flowsByPk(id: $flowId) {
      id
      organizationId
      deletedAt
      name
      description
      nodes
      edges
      entryNodeId
      voiceConfig
      languageConfig
      currentPublicationId
    }
  }
`);

export const FlowPublicationsSubscription = graphql(`
  subscription FlowPublications($flowId: Uuid!) {
    flowPublications(where: { flowId: { _eq: $flowId } }, orderBy: { publishedAt: DESC }, limit: 20) {
      id
      publishedAt
      publishedByUser {
        id
        firstName
        lastName
        email
      }
    }
  }
`);

export const ElevenLabsVoicesSubscription = graphql(`
  subscription ElevenLabsVoices {
    elevenLabsVoices(orderBy: { name: ASC }) {
      id
      voiceId
      name
      gender
      accent
      age
      previewUrl
      recommendedModelId
    }
  }
`);

export const OrganizationCrmVariablesSubscription = graphql(`
  subscription OrganizationCrmVariables($organizationId: Uuid!) {
    organizationsByPk(id: $organizationId) {
      id
      crmIntegration {
        id
        config
      }
    }
  }
`);

export const CreateFlowMutation = graphql(`
  mutation CreateFlow(
    $organizationId: Uuid!
    $name: String!
    $description: String
    $nodes: Jsonb!
    $edges: Jsonb!
    $entryNodeId: String!
    $voiceConfig: Jsonb!
  ) {
    insertFlowsOne(
      object: {
        organizationId: $organizationId
        name: $name
        description: $description
        nodes: $nodes
        edges: $edges
        entryNodeId: $entryNodeId
        voiceConfig: $voiceConfig
      }
    ) {
      id
    }
  }
`);

export const RenameFlowMutation = graphql(`
  mutation RenameFlow($flowId: Uuid!, $name: String!) {
    updateFlowsByPk(pkColumns: { id: $flowId }, _set: { name: $name }) {
      id
      name
    }
  }
`);

export const UpdateFlowDraftMutation = graphql(`
  mutation UpdateFlowDraft(
    $flowId: Uuid!
    $nodes: Jsonb!
    $edges: Jsonb!
    $entryNodeId: String
    $voiceConfig: Jsonb
    $languageConfig: Jsonb
  ) {
    updateFlowsByPk(
      pkColumns: { id: $flowId }
      _set: {
        nodes: $nodes
        edges: $edges
        entryNodeId: $entryNodeId
        voiceConfig: $voiceConfig
        languageConfig: $languageConfig
      }
    ) {
      id
    }
  }
`);

export const ElevenLabsAvailabilitySubscription = graphql(`
  subscription ElevenLabsAvailability {
    elevenLabsVoicesAggregate {
      aggregate {
        count
      }
    }
  }
`);
